import { BadgeCheck, BookCheck, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ContentBadges } from "@/components/teacher/ContentBadges";
import { Fold } from "@/components/teacher/Collapsible";

const titleOf = (kind, i) => (kind === "pools" ? i.name : kind === "activities" ? i.title : i.pool_names?.join(", ") || i.activity?.title || i.code);
const OPEN = { pools: "Aç", activities: "Başlat", rooms: "Oyunu aç" };

// Uzman Onaylı ve Müfredat Uyumlu içerikler, Hazır Paketlerin üstünde vitrinde öne çıkar.
export const Showcase = ({ kind, items, onOpen }) => {
  const shown = items.filter((i) => !i.archived && (i.quality || []).some((q) => q === "expert" || q === "curriculum"))
    .sort((a, b) => (b.quality || []).length - (a.quality || []).length || (b.like_count || 0) - (a.like_count || 0)).slice(0, 8);
  if (!shown.length) return null;
  return (
    <Fold id={`showcase-${kind}`} title={`Rozet vitrini · ${shown.length}`} icon={<Star className="h-5 w-5 text-[#FACC15] fill-[#FACC15]" />}>
      <div data-testid={`showcase-${kind}`} className="space-y-3">
      <p className="text-sm text-slate-400">Uzman onaylı ve müfredat uyumlu içerikler.</p>
      <div className="flex gap-3 overflow-x-auto pb-2 snap-x">
        {shown.map((i) => (
          <div key={i.id} className="snap-start shrink-0 w-72 rounded-2xl p-4 flex flex-col gap-2 border border-sky-400/40 bg-gradient-to-br from-sky-500/10 to-emerald-500/10" data-testid={`showcase-item-${i.id}`}>
            <div className="flex gap-1.5 text-sky-300">
              {i.quality.includes("expert") && <BadgeCheck className="h-5 w-5" />}
              {i.quality.includes("curriculum") && <BookCheck className="h-5 w-5 text-emerald-300" />}
              <span className="text-xs text-slate-400 ml-auto truncate">{i.owner_name}</span>
            </div>
            <p className="font-bold leading-tight line-clamp-2">{titleOf(kind, i)}</p>
            <ContentBadges kind={kind} item={i} compact max={2} />
            <Button size="sm" variant="outline" className="mt-auto self-start" disabled={i.locked} onClick={() => onOpen(i)} data-testid={`showcase-open-${i.id}`}>{OPEN[kind]}</Button>
          </div>
        ))}
      </div>
      </div>
    </Fold>
  );
};
